import { Component, OnInit } from '@angular/core';
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
@Component({
  selector: 'app-otopicdetail',
  templateUrl: './otopicdetail.component.html',
  styleUrls: ['./otopicdetail.component.css']
})
export class OtopicdetailComponent implements OnInit {

  formoption:any;
  topicId:any=0;
  constructor(private router: Router,private route: ActivatedRoute) { 

    this.route.params.subscribe((params: Params) => {
      if(params['id']){
        try{
          if(this.topicId > 0){
            this.topicId = atob(params['id']);
            this.formoption={createpost:false,otopicId:this.topicId}
           
          }else{
            this.topicId = atob(params['id']);
            this.formoption={createpost:false,otopicId:this.topicId}
          }         
        }catch(e){
          this.topicId=0;

        }
      }   
    });

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/otopicdetail/otopicdetail.component.ts